export const loadState = (state) => {
  try {
    const serializedState = sessionStorage.getItem(state)
    if (serializedState === null) return undefined
    return JSON.parse(serializedState)
  } catch (err) {
    console.error("Error loading from sessionStorage", err)
    return undefined
  }
}

export const saveState = (state, data) => {
  try {
    const serializedState = JSON.stringify(data)
    sessionStorage.setItem(state, serializedState)
  } catch (err) {
    console.error("Error saving to sessionStorage", err)
  }
}
